import { Popup } from "antd-mobile";
import React from "react";

import CustomNavbar from "../CustomNavbar";
import "./style.scss";

const CustomPopup = (
  {
    title = "",
    onClose = () => {},
    children = null,
    visible = false,
    destroyOnClose = false,
    afterClose = () => {},
    right = null,
    navBarStyle = {},
    className = "",
    backIcon = true,
  },
  ...props
) => {
  return (
    <Popup
      className={`${className} custom-drawer-popup`}
      {...props}
      visible={visible}
      destroyOnClose={destroyOnClose}
      afterClose={afterClose}
      position="right"
    >
      <CustomNavbar onBack={onClose} style={{ ...navBarStyle }} right={right} backIcon={backIcon}>
        {title}
      </CustomNavbar>
      <div className="container">{children}</div>
    </Popup>
  );
};

export default CustomPopup;
